import { render, staticRenderFns } from "./ComercioExteriorCfdiRelacionado.vue?vue&type=template&id=2d6caa16&"
import script from "./ComercioExteriorCfdiRelacionado.vue?vue&type=script&lang=js&"
export * from "./ComercioExteriorCfdiRelacionado.vue?vue&type=script&lang=js&"
import style0 from "./ComercioExteriorCfdiRelacionado.vue?vue&type=style&index=0&id=2d6caa16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports